function initNews() {
  const newsList = document.querySelectorAll('.news__list');

  if (newsList) {
    newsList.forEach(slider => {
      const swiper = new Swiper(slider, {
        slidesPerView: 3,
        spaceBetween: 20,

        navigation: {
          nextEl: slider.querySelector('.swiper-next-btn'),
        },

        breakpoints: {
          0: {
            slidesPerView: 1.4,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          1280: {
            slidesPerView: 3,
            spaceBetween: 20,
          }
        },
      });
    });
  }

  const promotionsList = document.querySelectorAll('.promotions__list');

  if (promotionsList) {
    promotionsList.forEach(slider => {
      const swiper = new Swiper(slider, {
        slidesPerView: 4,
        spaceBetween: 20,

        navigation: {
          nextEl: slider.querySelector('.swiper-next-btn'),
        },

        breakpoints: {
          0: {
            slidesPerView: 1.4,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 20,
          }
        },
      });
    });
  }
}

export { initNews };
